export const TeamLeagueDetailsHeaderSkeleton = () => {
	return (
		<div className="animate-pulse bg-white pt-2 shadow-md">
			<div className="flex flex-col flex-wrap items-center gap-10 bg-white p-3 sm:flex-row sm:flex-nowrap sm:gap-0 sm:p-4 sm:px-6">
				<div className="-mb-3 flex bg-white text-base font-semibold text-gray-900 sm:hidden sm:text-lg">
					<div className="h-6 w-32 rounded bg-gray-300"></div>
				</div>

				<div className="flex w-full gap-4 sm:w-1/2 lg:w-[70%]">
					<div className="h-[150px] w-[300px] max-w-[45%] rounded bg-gray-300"></div>

					<div className="flex flex-col justify-center gap-4">
						<div className="hidden h-6 w-48 rounded bg-gray-300 sm:flex"></div>

						<div className="flex w-fit items-center rounded-md border border-gray-300 px-2 py-1 text-sm">
							<div className="mr-1 size-[6px] rounded-full bg-gray-300"></div>
							<div className="h-4 w-24 rounded bg-gray-300"></div>
						</div>

						<div className="flex items-center">
							<div className="mr-2 size-5 rounded bg-gray-300"></div>
							<div className="h-5 w-36 rounded bg-gray-300"></div>
						</div>
					</div>
				</div>

				<div className="ml-0 w-full px-0 pb-4 pt-10 sm:ml-auto sm:w-auto sm:p-0">
					<div className="h-10 w-40 rounded bg-gray-300"></div>
				</div>
			</div>

			<div className="w-full">
				<div className="h-10 w-full bg-gray-300"></div>
			</div>
		</div>
	);
};
